// modules
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FaTimes, FaEdit, FaEye, FaExternalLinkAlt } from 'react-icons/fa';

// styles
import {
  ComponentDeleteButton,
  ComponentEditButton,
  ComponentPreviwButton,
  ComponentContent,
  ComponentIconX,
  ComponentDatasourceLabel,
  ComponentDatasourceInput
} from '../../../styles/home';

class Twitter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isPreview: false
    };
  }

  /**
   * キープレスhandle
   * @param {object} e
   * @type  {void}
   */
  handleOnKeyPress = (e) => {
    if (e.key === 'Enter') {
      document.getElementById(this.props.component.id + '-data-source-input').blur();
      document.getElementById(this.props.component.id + '-preview').click();
    }
  }

  render() {
    const { component, handleChangeDelete, handleBlurDatasourceInput } = this.props;

    return (
      <Container fluid>
        <Row>
          <ComponentContent>
            <Row>
              <Col>
                <ComponentIconX/>
              </Col>
            </Row>
            <Row>
              <Col>
                {(() => {
                  const item = component.items[0];
                  if (this.state.isPreview) {
                    // ユーザー名またはURLからXプロフィールリンクを生成
                    const username = item.data_source?.replace(/^@/, '').replace(/^https?:\/\/(www\.)?(twitter|x)\.com\//, '');
                    const xUrl = username ? `https://x.com/${username}` : '';

                    return (
                      <div style={{
                        margin: '60px 0 20px',
                        padding: '20px 20px',
                        textAlign: 'center',
                        border: '1px solid #e1e8ed',
                        borderRadius: '8px',
                        backgroundColor: '#f7f9fa'
                      }}>
                        <ComponentIconX style={{ marginBottom: '18px', fontSize: '24px' }} />
                        <div style={{ marginBottom: '20px', fontSize: '16px', fontWeight: 'bold' }}>
                          @{username}
                        </div>
                        {xUrl && (
                          <a
                            href={xUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              padding: '10px 20px',
                              backgroundColor: '#000000',
                              color: 'white',
                              textDecoration: 'none',
                              borderRadius: '20px',
                              fontSize: '14px',
                              fontWeight: 'bold'
                            }}
                          >
                            Xプロフィールを見る
                            <FaExternalLinkAlt style={{ marginLeft: '8px', fontSize: '12px' }} />
                          </a>
                        )}
                      </div>
                    )
                  } else {
                    return (
                      <div>
                        <ComponentDatasourceLabel>X（旧Twitter）ユーザー名</ComponentDatasourceLabel>
                        <ComponentDatasourceInput
                          id={component.id + '-data-source-input'}
                          data-component-id={component.id}
                          data-item-id={item.id}
                          type='text'
                          onBlur={handleBlurDatasourceInput}
                          onKeyPress={this.handleOnKeyPress}
                          defaultValue={item.data_source}
                          placeholder='@なしで入力してください'/>
                      </div>
                    )
                  }
                })()}
              </Col>
            </Row>
          </ComponentContent>
        </Row>
        <ComponentDeleteButton
          data-component-id={component.id}
          size='sm' onClick={handleChangeDelete}>
          <FaTimes />
        </ComponentDeleteButton>
        <ComponentEditButton
          size='sm' onClick={ () => { this.setState({isPreview : false}) } }>
          <FaEdit />
        </ComponentEditButton>
        <ComponentPreviwButton
          id={component.id + '-preview'}
          size='sm'
          onClick={ () => { this.setState({isPreview : true}) } }>
          <FaEye />
        </ComponentPreviwButton>
      </Container>
    );
  }
}

export default Twitter;
